
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Dette er skabt af
                    <a href="${0}">Folksonomy Engine-projektet</a>. Tøv ikke
                    med at deltage eller give feedback`,
'h5d824b4954e56ea5': html`Scan dine <span class="everyday">dagligdags</span> <span class="foods">fødevarer</span>`,
'h6bdd1b427aa985a4': html`Dette værktøj giver dig mulighed for at rette ingredienslisten. Du kan tilføje, fjerne eller redigere ingredienslisten
                .
                <br>
                Dette tegn <span class="highlight">␣</span> repræsenterer et mellemrum.
                <br>
                Dette tegn <span class="highlight">↩︎</span> repræsenterer et linjeskift. `,
'hb28f1f2ec1744ee9': html`Disse egenskaber oprettes og arkiveres af brugere til enhver form for anvendelse. Du er
                    velkommen til at tilføje dine egne. De egenskaber og værdier, du opretter
                    <strong>, skal være faktuelle</strong>. Du kan dykke ned i
                    <a href="${0}">listen over egenskaber, der allerede bruges af fællesskabet</a>
                    eller udforske
                    <a href="${1}">dokumentationen for egenskaber og dens søgemaskine</a>.`,
's000a5b76bd3a01c2': `Indlæser egenskaber...`,
's000d98595e959c1e': `Hent den på Google Play`,
's013bdc8cf0d3583d': `Hjælp os med ingredienserne`,
's01d2865e3e1d5501': `Tak for din hjælp!`,
's02ce7a2e7c1b020b': `Valider afgrøde`,
's03e9c8114521b998': `Jeg redigerer ingredienserne`,
's05ec315d9308091a': `Stregkode hjørner ikon`,
's061eb5af92512c85': `Gemt! Kan du hjælpe med en til?`,
's06847c221c4c0bc1': `Jeg vil gerne oprette en egenskab til [beskriv din brugsanvisning]...`,
's06f6c6f99db6b552': `Original`,
's081e2ad82db71e1d': `Grupperede værdier`,
's09205907b5b56cda': `Nej`,
's0b4235aae602a950': `dedikeret dokumentation`,
's0bb2d48532acc455': `Download CSV-fil`,
's0d5b7fee0311db68': `Egenskab`,
's0fb218abc2e157ed': `Ugyldiggør billede`,
's100c4928cc74642a': `støtte forskning inden for folkesundhed.`,
's10db5498186c083b': `Annuller beskæring`,
's11a18a69b30b65ed': `Hjælp os med at rette fejl i ingredienslisten`,
's1205d5f6fccf8e69': `Ejendomsværdi`,
's15d64a0a6715285a': `Ny nøgle`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Udvælgelsesområde`,
's1a52515ec8ddade8': `Produkt stregkode`,
's1c5031113de500ce': `holde vores database åben &amp; tilgængelig for alle,`,
's1dc4daf989c71284': `Hjælp os med at rette næringsoplysningerne`,
's1e00019dc454872d': `Angiv venligst et ejendomsnavn ved hjælp af attributten property-name.`,
's1e49126af0935a5b': `Liste over produkter, der bruger denne egenskab`,
's21e73088de6f26f3': `Tilgængelig i App Store`,
's255857544a9d5ec0': `Nulstil`,
's25e94495991e95ba': `Tak for din hjælp! Kan du hjælpe med et andet spørgsmål?`,
's2ceb11be2290bb1b': `Annullér`,
's2db7b654c0a9bde0': `Dokumentér ejendommen`,
's300b3a6ee4e1252d': str`Dårlig match ${0}%`,
's33f786bb6b4f0cf4': `Afgrøderesultat`,
's33f85f24c0f5f008': `Gem`,
's34be4af4e8fec4ae': `Spørg først fællesskabet`,
's36d86adc823cbfa6': `Før du opretter en ny ejendom, skal du diskutere den med lokalsamfundet:`,
's3781d25aa51a736c': `Dokumentation af Folksonomy-motoren`,
's383ae4449428b61e': `Nulstil beskæring`,
's39bcf88721a1e8ee': `Nulstil valg`,
's39e14e14300694c7': `Dokumentation og retningslinjer`,
's3b430cfa5c1fe7f4': str`Dokumentation for ${0}`,
's3f4e4b52f230a892': `Billedlærred`,
's417b90913e05bc17': `Forhåndsvisning`,
's41f7dca46d3f1b4a': `Værdi`,
's422bba9636ce2489': `Centerbillede`,
's42dd66b2441566fd': `Centerikon`,
's43df2e8395f6834e': str`Giv venligst til vores ${0} Fundraiser`,
's453188ea728f64da': `Tilføj et næringsstof`,
's453ab0dbb9b5c777': `Tilpas størrelse til højre`,
's475b08749d0706ed': `Hjælp os med at informere millioner af forbrugere rundt om i verden om, hvad de spiser`,
's49730f3d5751a433': `Indlæser...`,
's4bbc7472834a9686': `Din browser understøtter ikke stregkodescanning.`,
's4d42cc7e00076a3b': `Produktantal`,
's4df2f533c0c1e7d0': `Billedkontroller`,
's4e94adf723979402': `Open Food Facts har brug for din hjælp med dette produkt.`,
's4f4886341969d552': `Flyt markering`,
's4f751fb9b3ed766c': `Oprettelse af en ny ejendom`,
's547c12ae169d00bc': `Tilgængelig på F-Droid`,
's5560fb119e40923d': `Indtast ejendomsnavn...`,
's55d7249883a98ca1': `om denne ejendom på Open Food Facts wiki`,
's565867d84c04aea2': `Filteregenskaber...`,
's5666afe5cd0166de': `Ret venligst fejlene eller rediger teksten, før du bekræfter`,
's57472465a23b41db': `Værdier`,
's58e1eeea7a60ae51': `Indlæser produkter...`,
's59df20feee978e5b': `Fejl: Ugyldig værdi.`,
's5c92c0051d44b6de': `Hjælp os med at rette næringsoplysningerne.`,
's5dd6f12783fca34f': `Rediger ingredienslisten`,
's5e8250fb85d64c23': `Luk`,
's5ed03bb1f3a15949': `Billede`,
's6306a31415aea913': `JEG STØTTER`,
's6498dfe4855bb3a7': `enhed`,
's64ef2a6c2dd1d3d1': `Redigér`,
's66413c24dcf680e2': `Spring over`,
's67ae6594857a4d57': `Tak for dit bidrag!`,
's6cee7cad81dfedd1': `Beskåret billede`,
's6d7b6cdedaadfb6e': `Hver donation tæller! Vi sætter pris på din støtte til at bringe yderligere fødevaregennemsigtighed i verden.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Godt match ${0}%`,
's71a5c9f4b68ef4d4': `Antal`,
's74cb3d66f6a668e1': `Dokumentation`,
's787dd11bed0dc88a': `Tilpas størrelsen til venstre`,
's7ce4fd9430e80cea': `værdi`,
's801a05fa8e881f37': `Få mere at vide om oprettelse af ejendomme og retningslinjer:`,
's8038273de2cf8b73': `Vælg venligst et område at beskære.`,
's839cc2908a5387f2': `Filtrer stregkoder...`,
's86197dcf3e96af64': `Gennemse og søg i eksisterende ejendomme`,
's8a63be30a129a59c': `Ændr størrelsen på bunden`,
's8a8bfd67f2dd2810': `Download OFF-appen med denne QR-kode`,
's8af61807443f32a4': `Handlinger`,
's8b33c244759d7bd4': `Ændr størrelse øverst til højre`,
's8db84aa4bc949af2': `Dokumentér den nye ejendom`,
's8f839a03997a16d7': `Se produkt`,
's901ae1e236ac45d3': `Annuller sletning`,
's907f7a97c6b29425': `Vær opmærksom på, at datamodellen kan blive ændret. Brug på eget ansvar.`,
's95d23d03f9147581': `Zoom ud`,
's976dfd19ef58a1e1': `Klik for at scanne en stregkode og finde ud af dens detaljer (sundhed, præferencer osv.)`,
's98ff35f2a00dc60d': `Ingredienser:`,
's9a7f60fce090ecaf': `Kunne ikke indlæse egenskaber. Prøv igen senere.`,
's9b87abd68fb9df45': `Ikke fundet? Opret ny nøgle {value}`,
's9c0f52425fd2f07e': `Matcher muligvis ikke`,
's9fc41f789c63b40d': `Produkter`,
'sa1fa766e0d5634d7': `Ingen score tilgængelig`,
'sa548778b24054030': `Udforsk alle bidragede egenskaber fra Folksonomy Engine-projektet. Disse egenskaber giver yderligere metadata og indsigt om produkter i Open Food Facts-databasen.`,
'sa63907958bd0ec4b': `Ændr størrelsen øverst til venstre`,
'sa95b4224f685a36a': `Luk modal`,
'sab56a1d439576fd6': `Forslagsikon`,
'sac47ea2901d04c15': `Ændr størrelse nederst til venstre`,
'sb125227d436c2925': `Søg efter dit ejendomskoncept i den eksisterende ejendomsdatabase:`,
'sb125568d43642e6f': `Besvar spørgsmål om produktet.`,
'sb1c538e038f9b214': str`Meget godt match ${0}%`,
'sb28639570ff3b852': `liste over alle ejendomme`,
'sb3bdd638a58d30f4': `engagere et fællesskab af engagerede borgere,`,
'sb3cbcc1bd0fff140': `Når du har bekræftet, at din ejendom ikke eksisterer, og fællesskabet er enig i, at den er nyttig, skal du først dokumentere den i wikien.`,
'sb3d4f79d9d8b71e5': `Indsend`,
'sb560fa37a7bfb6c2': `Ingen produkter fundet til denne ejendom.`,
'sb7f72e4c8a2d3357': `Filtrer værdier...`,
'sb8178320160f84ea': `Vis afgrøde`,
'sbad7d2734149470b': `Bekræftelse`,
'sbb623d6b18d966a0': `Næringsfakta er vist på emballagen:`,
'sbd6be5cde472f37c': `Alle indsigter er blevet besvaret! Tak for din hjælp!`,
'sbd9a0b2293b3cd3c': `Portionsstørrelse`,
'sbe472dc3c2685985': `Tilsvarende værdi`,
'sc0520e1732a5c568': `Udvid billede`,
'sc0cc559e7ede852a': `Tilpas størrelsen på toppen`,
'sc1c08d0cbcc3bd24': `Matcher ikke`,
'sc52696641af72b53': `Installér appen!`,
'sc5575e3107f87874': `Roter billedet til venstre`,
'sc57b630a7a70c61f': `Foreslået løsning`,
'sc681b137e8f604f7': `Bekræft sletning`,
'sc6daf8a31883f8b9': `Flyt billede`,
'sc895972c88d38ca5': `Folksonomy-ejendom`,
'sca0c3305aff570b8': str`pr. specificeret portion "${0}"`,
'scace072bef961918': `Rækker`,
'scb3b0671d7b7f640': `Ny værdi`,
'scb489a1a173ac3f0': `Ja`,
'scbab4bd737ba7934': str`gruppefotodonation ${0}`,
'scd21019c3cd618f3': `Deltag i Slack-diskussionen`,
'scdb6cad0b92721bf': `Ingen ejendomme fundet.`,
'scf23a05631f93732': `Bekræft sletning`,
'scfed2f270ef6a3aa': `Vælg område`,
'sd1022bc1ef9204f7': `Zoombart billede`,
'sd1077c055cf9ba6b': `Hjælp os med at validere produktets ingrediensliste.`,
'sd698d21ddecba56b': `Hej! Du kan hjælpe os med at forbedre produktinformationen ved at besvare følgende dele:`,
'sd82bc2decefa621b': `forblive uafhængig af fødevareindustrien,`,
'sdb97e5976482606e': `Tjek om en ejendom allerede findes`,
'sdbf806fefc584115': `Du burde finde en`,
'sdc673e73b5c13aea': `Slet`,
'sdc792b75f1edcaba': `Hjælp os med at rette stavningen af ingredienserne.`,
'sdca5deead576ceee': `Ændr størrelse nederst til højre`,
'sdcc2555c5dde524f': `Er du sikker på, at du vil slette dette element? Denne handling kan ikke fortrydes.`,
'se206feec7ec57b28': `pr. 100g`,
'se419a9ab36987490': `Ugyldiggør`,
'se5127cf0f92e7e48': `Tip: Du kan også finde`,
'se773f50d2a16d481': `Roter billedet til højre`,
'sebb2c6c830a44574': `teknisk infrastruktur (hjemmeside/mobilapp) &amp; et lille fast team`,
'sec6377f3c4e9b28c': `Jeg vil foreslå en bedre afgrøde`,
'seea3800e27baa686': `Individuelle produkter`,
'sefaba4adc4ec9219': `Folksonomi-egenskaber`,
'seffa8ca49175b5f0': `Personlige egenskaber`,
'sf44a6b3b232c28ea': str`Erstat den aktuelle værdi med ${0}`,
'sf4cd86a2f5ef2588': `Produktstregkode`,
'sf57a61152168cc81': `Hjælp os med at korrigere ingrediensdetekteringen`,
'sf88b90b8ba23871c': `Ukendt match`,
'sf9aee319a006c9b4': `Tilføj`,
'sfacbbe968fa7d773': `Ejendommens navn:`,
'sfc40ea3d5d5aa6f8': `Dine donationer finansierer den daglige drift af vores non-profit forening:`,
'sfe87465d50530725': `Tilsvarende værdi`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  